import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../../partials/LoadingSpinner';

import { uploadThresholds } from '../../../redux/actions/thresholds';

const ThresholdUpload = ({ payload, thresholds, upload }) => {
  const [submitted, setSubmitted] = useState(false);
  const [file, setFile] = useState();
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    if(e.target.files[0]) {
      setSubmitted(false);

      if(e.target.files[0].size <= 1048576) {
        setError(null);
        setFile(e.target.files[0]);
      } else {
        setError('File size is too large (max size 1MB).');
        setFile(null);
      }

    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (file !== undefined && !file.cancelled && file.name) {
      upload(payload, file);
    }
  }

  return(
    <div>
      <div>
        <a target="_blank" href="https://athousandapps.com/ecwid/upload-suggestion-thresholds-csv-2/">
          Read more about the expected CSV file format and generating a CSV
        </a>
      </div>

      <h4>Upload Inventory Thresholds CSV:</h4>
      <div className="muted">
        Supported file types: csv
      </div>
      <form onChange={ (e) => handleChange(e) } onSubmit={ (e) => handleSubmit(e) }>
        <input type="file" name="file" accept="text/plain, .csv" />
        <br/>
        <br/>
        <button className="btn btn-primary" disabled={submitted || !file}>
          <span className="svg-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 11a4 4 0 0 1-4 4H4.5a4.5 4.5 0 0 1-1.214-8.834 6.002 6.002 0 0 1 11.648.944A4.002 4.002 0 0 1 18 11zm-4-3a3 3 0 0 1 0 6H4.5a3.5 3.5 0 0 1-1.442-6.69.5.5 0 0 0 .99-.004 4.988 4.988 0 0 1 .051-.302 5.002 5.002 0 0 1 9.803.006A.5.5 0 0 0 14 8z" fill="currentColor"/></svg>
          </span>
          <span className="gwt-InlineLabel">Upload Inventory Thresholds CSV</span>
        </button>
      </form>
      <br/>
      <br/>
      { thresholds.uploadStatus !== 'waiting' &&  
        <div>
          { thresholds.uploadStatus === 'failure' &&
            <p>
              An error occurred while uploading or processing this CSV. Please reach out to support@athousandapps.com if you need help.
            </p>
          }

          { thresholds.uploadStatus === 'processing' &&
            <p>
              CSV is processing. View your store's thresholds to see creation results. If errors occur, we'll reach out to see if they can be resolved!
            </p>
          }

          { thresholds.uploadStatus === 'uploading' &&
            <p>
              Uploading CSV...
            </p>
          }

          { thresholds.uploadStatus === 'uploaded' &&
            <p>
              CSV successfully uploaded! Starting processing...
            </p>
          }

          { thresholds.uploadStatus === 'processing_requested' &&
            <p>
              CSV successfully uploaded! Processing requested...
            </p>
          }
        </div>
      }
    
    </div>
  )
}

const mapStateToProps = state => ({
  thresholds: state.thresholds,
});

const mapDispatchToProps = (dispatch) => ({
  upload: (payload, file) => dispatch(uploadThresholds(payload, file))
});

export default connect(mapStateToProps, mapDispatchToProps)(ThresholdUpload);